namespace Areas.CollaborationAreas {
    "use strict";

    let formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {
        formCrudOps = new FormCrudOperations("CollaborationAreas");
    }

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function deleteRecord() {
        formCrudOps.deleteRecord();
    }
}